import { updateAllBadges } from './badges';

// Manages dropdown toggles, mark-as-read actions, and simple in-menu interactions.
// Returns a cleanup function to remove listeners.
export function initDropdowns(root: ShadowRoot): () => void {
  const queryAll = (selector: string, ctx: ParentNode = root) => Array.from(ctx.querySelectorAll(selector));

  const closeAll = (except?: Element) => {
    queryAll('.dropdown-toggle[aria-expanded="true"]').forEach((btn) => {
      if (!except || btn !== except) (btn as HTMLElement).setAttribute('aria-expanded', 'false');
    });
  };

  const onShadowClick = (event: Event) => {
    const target = (event.composedPath?.()[0] as Element) || (event.target as Element);
    const toggle = target.closest?.('.dropdown-toggle');

    if (toggle && root.contains(toggle)) {
      const expanded = (toggle as HTMLElement).getAttribute('aria-expanded') === 'true';
      closeAll(toggle as Element);
      (toggle as HTMLElement).setAttribute('aria-expanded', expanded ? 'false' : 'true');
      event.preventDefault();
      return;
    }

    const markBtn = target.closest?.('[data-action="mark-all"]');
    if (markBtn && root.contains(markBtn)) {
      const menu = (markBtn as HTMLElement).closest('.dropdown-menu');
      if (menu) queryAll('.unread', menu).forEach((el) => el.classList.remove('unread'));
      updateAllBadges(root);
      return;
    }

    const alertItem = target.closest?.('.menu-notifications .alert-item');
    if (alertItem && root.contains(alertItem)) {
      (alertItem as HTMLElement).classList.remove('unread');
      updateAllBadges(root);
      return;
    }

    const msgItem = target.closest?.('.menu-messages .msg-item');
    if (msgItem && root.contains(msgItem)) {
      (msgItem as HTMLElement).classList.remove('unread');
      updateAllBadges(root);
      return;
    }

    const subLink = target.closest?.('.dropdown-menu.menu-apps .apps-sublinks .item');
    if (subLink && root.contains(subLink)) {
      const pane = (subLink as HTMLElement).closest('.pane');
      if (pane) queryAll('.item.is-active', pane).forEach((el) => el.classList.remove('is-active'));
      (subLink as HTMLElement).classList.add('is-active');
    }
  };

  const onDocClick = (event: MouseEvent) => {
    const path = event.composedPath ? event.composedPath() : [];
    if (!path.includes(root.host) && !path.includes(root)) closeAll();
  };

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') closeAll();
  };

  root.addEventListener('click', onShadowClick);
  window.addEventListener('click', onDocClick, true);
  window.addEventListener('keydown', onKeyDown);

  return () => {
    root.removeEventListener('click', onShadowClick);
    window.removeEventListener('click', onDocClick, true);
    window.removeEventListener('keydown', onKeyDown);
  };
}
